import React from 'react';
import type { IconsProps } from '@makemydeal/dr-sales-checkin-types';
import { StyledAddIcon } from './addIcon.style';

export const AddIcon: React.FC<IconsProps> = ({ fill = '#FFFFFF' }) => (
    <StyledAddIcon data-testid="add-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5 5H6.99998V0.5C6.99998 0.22375 6.77623 0 6.49998 0H5.49998C5.22373 0 4.99998 0.22375 4.99998 0.5V5H0.499998C0.223749 5 0 5.22375 0 5.5V6.5C0 6.77625 0.223749 7 0.499998 7H4.99998V11.5C4.99998 11.7762 5.22373 12 5.49998 12H6.49998C6.77623 12 6.99998 11.7762 6.99998 11.5V7H11.5C11.7762 7 12 6.77625 12 6.5V5.5C12 5.22375 11.7762 5 11.5 5Z"
            fill={fill}
        />
    </StyledAddIcon>
);
